// extracted by mini-css-extract-plugin
export var boldText = "main-module--bold-text--00374";
export var btn = "main-module--btn--bec21";
export var containerFluid = "main-module--container-fluid--3e826";
export var thinWhiteText = "main-module--thin-white-text--fd324";
export var titleH2 = "main-module--title-h2--546b5";
export var titleWhite = "main-module--title-white--ffe97";